import { connect } from 'react-redux';
import { branch, renderComponent, withPropsOnChange, compose } from 'recompose';

import Processing from '../Processing';
import { closeChargeModal } from '../../../register/payment/reducer/chargeModal/actions';

export default compose(
  connect(
    null,
    { closeChargeModal },
  ),
  withPropsOnChange(
    ['pending'],
    (props) => {
      if (props.pending) {
        props.closeChargeModal();
      }
    },
  ),
  branch(
    ({ pending }) => pending,
    renderComponent(Processing),
  ),
);
